import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';
import Icon, { IconList } from 'components/icon';
import { noDigitsCurrencyFormat } from 'utils/format-number';

import ArrowLeft from '../assets/arrow-left.svg';
import ArrowRight from '../assets/arrow-right.svg';
import Dash from '../assets/dash.svg';
import EquationBox from '../equation-box';
import { config, testId } from '../what-you-get-banner.settings';

import messages from './expanded-equation.i18n';
import styles from './expanded-equation.module.scss';

const ExpandedEquation: React.FunctionComponent<unknown> = () => {
  const { formatMessage, formatNumber } = useIntl();
  const translation = messages.pages.landing.whatYouGetBanner.expandedEquation;

  return (
    <Html.div className={styles.expandedEquation} testId={testId.expandedEquation}>
      <EquationBox
        className={styles.memberPurchases}
        header={formatMessage(translation.memberPurchases)}
        amount={formatNumber(config.memberPurchase, noDigitsCurrencyFormat)}
        footer={formatMessage(translation.toContribute)}
      />
      <ArrowLeft className={styles.arrowLeft} />
      <Html.div className={styles.column}>
        <EquationBox
          className={[styles.traffic, 'mb-4 pb-3']}
          header={formatMessage(translation.traffic)}
          amount={formatNumber(config.trafficPct, { style: 'percent' })}
          footer={formatNumber(config.trafficAmount, noDigitsCurrencyFormat)}
          variant="footerHighlight"
        />
        <EquationBox
          className={[styles.fees, 'px-1 pb-3']}
          header={formatMessage(translation.fees)}
          amount={formatNumber(config.feesPct, { style: 'percent' })}
          footer={formatNumber(config.feesAmount, noDigitsCurrencyFormat)}
          variant="footerHighlight"
        />
      </Html.div>
      <ArrowRight className={styles.arrowRight} />
      <EquationBox
        header={formatMessage(translation.shareCosts)}
        amount={formatNumber(config.shareCosts, noDigitsCurrencyFormat)}
      />
      <Dash className={styles.dash} />
      <EquationBox
        header={formatMessage(translation.ljShare)}
        amount={formatNumber(config.ljSharePct, { style: 'percent' })}
        footer={formatNumber(config.ljShareAmount, noDigitsCurrencyFormat)}
        variant="footerHighlight"
      />
      <Dash className={styles.dash} />
      <EquationBox
        header={formatMessage(translation.earnUpTo)}
        amount={formatNumber(config.earnUpToPct, { style: 'percent' })}
        footer={formatNumber(config.earnUpToAmount, noDigitsCurrencyFormat)}
        variant="highlight"
      />
      <Icon name={IconList.plusSolid} className={styles.plusIcon} />
      <EquationBox
        header={formatMessage(translation.extra)}
        amount={formatNumber(config.referralPct, { style: 'percent' })}
        footer={formatMessage(translation.referralBonus)}
        variant="highlight"
      />
    </Html.div>
  );
};

export default ExpandedEquation;
